import { Component } from "react";
import "../styles/trustbar.css";

class TrustBar extends Component {
  render() {
    return (
      <>
        <section className="py-4 border-bottom bg-white">
          <div className="container">
            <div className="row align-items-center text-center justify-content-lg-between">
              {/* 1. THE TITLE */}
              <div className="col-12 col-lg-auto mb-4 mb-lg-0 text-lg-start">
                <div
                  className="fw-bold text-secondary"
                  style={{ letterSpacing: "1px", fontSize: "14px" }}
                >
                  TRUSTED BY 2200+
                  {/* Keep the line break on desktop, hide it on mobile for a cleaner look */}
                  <br className="d-none d-lg-block" />
                  <span className="d-lg-none"> </span>
                  SCHOOLS
                </div>
              </div>

              {/* 2. THE LOGOS */}
              <div className="col-12 col-lg">
                <div className="row align-items-center justify-content-center justify-content-lg-end g-5">
                  <div className="col-6 col-md-4 col-lg-auto trust-logo">
                    <img
                      src="/assets-webp/logos/narayana.webp"
                      alt="Narayana Logo"
                      className="img-fluid"
                    />
                  </div>
                  <div className="col-6 col-md-4 col-lg-auto trust-logo">
                    <img
                      src="/assets-webp/logos/alif.webp"
                      alt="ALIF Logo"
                      className="img-fluid"
                    />
                  </div>
                  <div className="col-6 col-md-4 col-lg-auto trust-logo">
                    <img
                      src="/assets-webp/logos/bran.webp"
                      alt="Bran Logo"
                      className="img-fluid"
                    />
                  </div>
                  <div className="col-6 col-md-4 col-lg-auto trust-logo">
                    <img
                      src="/assets-webp/logos/shri.webp"
                      alt="Shri Logo"
                      className="img-fluid"
                    />
                  </div>
                  <div className="col-6 col-md-4 col-lg-auto trust-logo">
                    <img
                      src="/assets-webp/logos/chan.webp"
                      alt="Nirvana Chan Logo"
                      className="img-fluid"
                    />
                  </div>
                  <div className="col-6 col-md-4 col-lg-auto trust-logo">
                    <img
                      src="/assets-webp/logos/sreshta.webp"
                      alt="Shreshta Logo"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default TrustBar;
